module.exports = __webpack_public_path__ + "overview-a5b6df21/calendar-b2076b9c32c7225e928a1e0b9578bfbc.svg";